"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoonCard = void 0;
var MoonExpansion_1 = require("../../moon/MoonExpansion");
var Units_1 = require("../../Units");
var Card_1 = require("../Card");
var MoonCard = (function (_super) {
    __extends(MoonCard, _super);
    function MoonCard(properties, moonCardProperties) {
        var _this = _super.call(this, properties) || this;
        _this.moonCardProperties = moonCardProperties;
        return _this;
    }
    Object.defineProperty(MoonCard.prototype, "reserveUnits", {
        get: function () {
            return this.moonCardProperties.reserveUnits || Units_1.Units.EMPTY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MoonCard.prototype, "tilesBuilt", {
        get: function () {
            return this.moonCardProperties.tilesBuilt || [];
        },
        enumerable: false,
        configurable: true
    });
    MoonCard.prototype.canPlay = function (player) {
        return _super.prototype.canPlay.call(this, player) && player.canAdjustProduction(this.productionBox);
    };
    MoonCard.prototype.play = function (player) {
        var adjustedReserveUnits = MoonExpansion_1.MoonExpansion.adjustedReserveCosts(player, this);
        player.deductUnits(adjustedReserveUnits);
        player.adjustProduction(this.productionBox, { log: true });
        return undefined;
    };
    return MoonCard;
}(Card_1.Card));
exports.MoonCard = MoonCard;
//# sourceMappingURL=MoonCard.js.map